/**
 * Valida que si hay datos en algún campo, todos los campos deben tener datos
 * Si todos están vacíos, es válido
 * @param {Object} programPoint - Punto de programa a validar
 * @returns {boolean} true si es inválido, false si es válido
 */
export const hasInvalidProgramPoint = (programPoint) => {
  const code =
    programPoint?.code?.nombre ||
    (typeof programPoint?.code === 'string' ? programPoint?.code : null);
  const subCode =
    programPoint?.subCode?.nombre ||
    (typeof programPoint?.subCode === 'string' ? programPoint?.subCode : null);
  const cost = programPoint?.cost?.nombre || null;
  const clasification =
    programPoint?.clasification?.nombre ||
    (typeof programPoint?.clasification === 'string' ? programPoint?.clasification : null);

  const isEmpty = !code && !subCode && !cost && !clasification;

  // Si todos están vacíos, no es inválido
  if (isEmpty) return false;

  // Si alguno tiene datos, todos deben tener datos
  return !code || !subCode || !cost || !clasification;
};

export default hasInvalidProgramPoint;
